import OrderImages from './OrderImages';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withGlobalContent from '../../../hocs/withGlobalContent';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

const enhance = compose(
  withGlobalContent,
  withProps(({ items, globalContent: { orders } }) => {
    // An order with more than 3 products should display the first 2 product
    // thumbnails + text reading `+ n more` where n is the number of products
    // within the order minus 2
    const remainingItems = items.length > 3 && items.length - 2;
    return {
      items: items.reduce((result, { productInformation, ...item }, idx) => {
        if (remainingItems && result.length === 3) {
          return result;
        }
        if (remainingItems && idx === 2) {
          result.push({
            type: 'label',
            label: replaceTextWithValues(orders.moreItemsLabel, { remaining_items: remainingItems }),
          });
          return result;
        }
        result.push({
          type: 'image',
          ...item,
          ...productInformation,
        });
        return result;
      }, [])
    };
  }),
);

export default enhance(OrderImages);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderImages/index.js